import type { Rect } from 'types/documentServices';

export const getBoundingBoxStyles = ({ x, y, width, height }: Rect) => ({
  top: y,
  left: x,
  width,
  height,
});
